import axios from "axios";

export default {
  //baseURL: "https://intake.marketingmachine.ai/api/v1/",   // old api domin
  baseURL : `${process.env.REACT_APP_HOST}/api/v1/`,    // new api domain
   //baseURL : "http://localhost:5000/api/v1/",            // for text localhost
};
